import axios from "axios";
import { MAIN_URL } from "../../../Configurations/Urls";

/**
 * Laravel apiResource delete paths for PM list tables.
 * Keys match `tableName` / `filterModule` on list pages.
 */
export const PM_DELETE_API_BY_TABLE = {
  organization_project_tasks: "/api/project-management/project-tasks",
  organization_project_templates: "/api/project-management/project-templates",
  organization_project_types: "/api/project-management/project-types",
  organization_project_projects: "/api/project-management/projects",
  organization_project_subcategories: "/api/project-management/project-sub-categories",
  organization_project_task_schedule_time_logs:
    "/api/project-management/project-task-schedule-timelog",
  organization_project_team_members: "/api/project-management/project-team-members",
  organization_project_template_tasks:
    "/api/project-management/project-template-tasks",
  organization_project_task_schedules: "/api/project-management/project-task-schedule",
  organization_client_contacts: "/api/project-management/client-contacts",
  organization_project_categories: "/api/project-management/project-categories",
  organization_clients: "/api/project-management/clients",
  organization_project_milestones: "/api/project-management/project-milestone",
  organization_project_task_types: "/api/project-management/project-task-type",
  organization_project_task_templates: "/api/project-management/project-task-template",
  organization_project_task_subcategories:
    "/api/project-management/project-task-sub-category",
  organization_project_template_milestones:
    "/api/project-management/project-template-milestone",
  organization_project_task_recurrences: "/api/project-management/project-task-recurrence",
  organization_project_teams: "/api/project-management/project-teams",
  organization_project_task_categories: "/api/project-management/project-task-category",
};

export function resolvePmDeleteApiPath(tableName, filterModule) {
  if (tableName && PM_DELETE_API_BY_TABLE[tableName]) {
    return PM_DELETE_API_BY_TABLE[tableName];
  }
  if (filterModule && PM_DELETE_API_BY_TABLE[filterModule]) {
    return PM_DELETE_API_BY_TABLE[filterModule];
  }
  return null;
}

export function createPmDeleteHandler(apiBasePath) {
  if (!apiBasePath) return undefined;

  return async (id) => {
    const token = localStorage.getItem("token");
    await axios.delete(`${MAIN_URL}${apiBasePath}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
}

export function resolvePmDeleteFunc({
  DeleteFunc,
  deleteApiPath,
  tableName,
  filterModule,
}) {
  if (DeleteFunc) return DeleteFunc;

  const path = deleteApiPath || resolvePmDeleteApiPath(tableName, filterModule);
  return createPmDeleteHandler(path);
}
